import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import useStyles from './DeliveryPassLoginPrompt.styles';
const DeliveryPassLoginPrompt = (props) => {
    const { classes } = useStyles();
    return (_jsxs("div", { className: classes.container, children: [_jsx(Icon, { icon: "person", className: classes.icon }), _jsxs("div", { className: classes.deliveryPassText, children: ["Do you have a Delivery Pass?", _jsx(Link, { label: "Log in here", onClick: props.onLoginClick, className: classes.linkText })] })] }));
};
export default DeliveryPassLoginPrompt;
